import React, { Component } from 'react';
import img from '../../../assets/Agency/BookOfBusiness_Content/4652dd4a5d3aa12d8c22115cdb260943_html_1e64fb64e5fa396a.png';
class BookOfBusinessContent extends Component {
    render() {
        return (
            <div className="mi_main">
                <p ><b > Our Book:</b></p>
                <p>Agency can view commission amount earned for the month and year under Our Book menu. Agency can view details of commission earned which includes Invoiced amount, tax applied, adjustments if any and cheque details.</p>
                <img width="100%" height="100%" style={{marginBottom:"50px"}} alt="example"  src={img} />
            </div>
        )
    }
}
export default BookOfBusinessContent;
